<div id="create-new-proposal" class="new-proposal revealed">
    <h2 i18n="@@proposals.edit_proposal">Edit Proposal</h2>
    <div class="new-proposal__content">
        <form class="new-proposal__form" action="" method="get">
          <ul class="new-proposal__navigation">
              <li (click)="goToStep('client-detail')" [class.active]="activeStep.key == 'client-detail'" i18n="@@proposals.client_details">Client Details</li>
              <li (click)="goToStep('project-detail')" [class.active]="activeStep.key == 'project-detail'" i18n="@@proposals.project_details">Project Details</li>
              <li (click)="goToStep('quotes')" [class.active]="activeStep.key == 'quotes'" i18n="@@proposals.quote">Quote</li>
              <li (click)="goToStep('terms')" [class.active]="activeStep.key == 'terms'" i18n="@@proposals.terms_and_condition">Terms & Conditions</li>
          </ul>
            
        	<edit-proposal-client-detail 
            [proposal]="proposal"
            [hidden]="activeStep.key !== 'client-detail'"
            (onComplete)="onCompleteStep($event)"
            #clientDetailRef>
          </edit-proposal-client-detail>
            
          <edit-proposal-project-detail
          	[proposal]="proposal"
          	[hidden]="activeStep.key !== 'project-detail'"
          	(onComplete)="onCompleteStep($event)"
          	(triggerPrevious)="previousStep()">
        	</edit-proposal-project-detail>
            
          <edit-proposal-quotes 
            [proposal]="proposal"
            [defaultPaymentInfo]="defaultPaymentInfo"
            [client]="selectedClient"
            [hidden]="activeStep.key !== 'quotes'"
            (onComplete)="onCompleteStep($event)"
            (triggerPrevious)="previousStep()"
            (skipStep)="skipStep()">
        	</edit-proposal-quotes>
            
          <edit-proposal-terms 
          	[proposal]="proposal"
            [defaultTerms]="defaultTerms"
          	[hidden]="activeStep.key !== 'terms'"
          	(onComplete)="onCompleteStep($event)"
          	(triggerPrevious)="previousStep()"
          	(skipStep)="skipStep()">
    			</edit-proposal-terms>

          <edit-proposal-overview 
            [proposalData]="proposal"
            *ngIf="activeStep.key === 'overview'"
          	(triggerPrevious)="previousStep()"
          	[stepDetails]="steps"
            (saveProposal)="saveProposal($event)">
            	
          </edit-proposal-overview>
          
        </form>
    </div><!--end create-new-proposal-content  -->
</div><!-- end create-new-proposal-wrapper -->